namespace Matrix.Data {
    export interface DataExplorerListRequest extends Serenity.ListRequest {
        Identifier?: string;
    }
}
